"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KPIBox = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Icon = require("../Icon");
var _KPIBoxModule = _interopRequireDefault(require("./KPIBox.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const KPIBox = exports.KPIBox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    semantic = 'neutral',
    topContent,
    middleContent,
    bottomContent,
    iconName,
    iconSize = 'large',
    iconType = 'solid',
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...props,
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    className: (0, _classify.default)(_KPIBoxModule.default.wrapper, classNames?.wrapper),
    children: [!!iconName && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.SemanticIcon, {
      semantic: semantic,
      name: iconName,
      size: iconSize,
      type: iconType,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'icon'
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classify.default)(_KPIBoxModule.default.textContainer, classNames?.textContainer),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'content'
      }),
      children: [!!topContent && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classify.default)(_KPIBoxModule.default.topFoldContent, classNames?.topFoldContent),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'top'
        }),
        children: topContent
      }), !!middleContent && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classify.default)(_KPIBoxModule.default.middleFoldContent, classNames?.middleFoldContent),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'middle'
        }),
        children: middleContent
      }), !!bottomContent && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classify.default)(_KPIBoxModule.default.bottomFoldContent, classNames?.bottomFoldContent),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'bottom'
        }),
        children: bottomContent
      })]
    })]
  });
});